import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './VendorIdField.module.scss';

const VendorIdField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.vendorIdField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.vendorIdId}>
          {credentialForm.vendorIdLabel}
        </Label>
        <TextField
          id={credentialForm.vendorIdId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

VendorIdField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

VendorIdField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default VendorIdField;
